// Short two-note "message arrived" chime, synthesized with the Web Audio API
// so chat notifications don't need a bundled audio asset. Browsers block audio
// before any user interaction, so a failure here is expected/harmless and
// simply skipped. Kept identical to the client-frontend's version so both
// sides of the chat sound the same.
export function playMessageTone() {
  if (typeof window === "undefined") return;

  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;

    const ctx = new AudioContextClass();
    const now = ctx.currentTime;

    [880, 1175].forEach((frequency, i) => {
      const start = now + i * 0.12;
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, start);

      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.2, start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.18);

      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(start);
      oscillator.stop(start + 0.2);
    });

    setTimeout(() => ctx.close(), 500);
  } catch (error) {
    // Autoplay restrictions or lack of Web Audio support — ignore.
  }
}
